import { useState } from 'react';
import Sidebar from '@/components/admin/Sidebar';
import Topbar from '@/components/admin/Topbar';

export const AdminLayout = ({ title, children }) => {
    const [collapsed, setCollapsed] = useState(false);
    return (
        <div className="min-h-screen flex bg-background">
            <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
            <div className="flex-1 flex flex-col min-w-0">
                <Topbar title={title} />
                <main data-testid="admin-content" className="flex-1 p-4 sm:p-6 lg:p-8 max-w-full">{children}</main>
            </div>
        </div>
    );
};

export default AdminLayout;
